import React from 'react';
import AwesomeSlider from 'react-awesome-slider';
import withAutoplay from 'react-awesome-slider/dist/autoplay';
import 'react-awesome-slider/dist/styles.css';
import img1 from '../assets/banner/datacenter.jpg';
import img2 from '../assets/banner/ciudad.png';
import img3 from '../assets/img/telefonia.jpg';
import video from '../assets/video/video.mp4';

const AutoplaySlider = withAutoplay(AwesomeSlider);

const Slider = () => {
  return (
    <AutoplaySlider 
      play={true}
      cancelOnInteraction={false}
      interval={6000}
      bullets={false}
    >
      <div className="awssld__content box-center">
        <video autoPlay={true} src={video} controls={false}></video>
        <div className="backdrop"></div>
        <div style={{ position: 'absolute', color: 'white' }}>
          <div className="text-center container">
            <h2 className="g-font-size-title h1 g-font-weight-800 mb-4">DESARROLLO DE SOFTWARE</h2>
            <p className="lead g-font-weight-800 g-font-size-subtitle">
              Desarrollamos software a la medida para dar una solución escalable, precisa y
              eficiente a los problemas de todo tipo que cada organización cuenta.
            </p>
          </div>
        </div>
      </div>
      <div className="box-center" data-src={img1}>
        <div className="backdrop"></div>
        <div style={{ position: 'absolute', color: 'white' }}>
          <div className="text-center container">
            <h2 className="g-font-size-title h1 g-font-weight-800 mb-4">DATACENTER</h2>
            <p className="lead g-font-weight-800 g-font-size-subtitle">
              Con una robusta infraestructura de 3 Data Centers aseguramos la continuidad
              operacional de las plataformas críticas de nuestros clientes.
            </p>
          </div>
        </div>
      </div>
      <div className="box-center" data-src={img2}>
        <div className="backdrop"></div>
        <div style={{ position: 'absolute', color: 'white' }}>
          <div className="text-center container">
            <h2 className="g-font-size-title h1 g-font-weight-800 mb-4">INTERNET</h2>
            <p className="lead g-font-weight-800 g-font-size-subtitle">
              Ofrecemos enlaces de Internet estables con baja latencia y velocidades de hasta 1
              Gbps. Estamos conectados con las CDN más importantes del mundo y a los PITs más
              grandes de Chile para asegurar la mejor conectividad.
            </p>
          </div>
        </div>
      </div>
      <div className="box-center" data-src={img3}>
        <div className="backdrop"></div>
        <div style={{ position: 'absolute', color: 'white' }}>
          <div className="text-center container">
            <h2 className="g-font-size-title h1 g-font-weight-800 mb-4">TELEFONIA IP CLOUD</h2>
            <p className="lead g-font-weight-800 g-font-size-subtitle">
              Una solución flexible que se adapta a todo tipo de escenarios y permite altos niveles
              de personalización. Traslada fácilmente los teléfonos físicos de tus colaboradores a
              sus casas para aumentar la productividad con Home Office.
            </p>
          </div>
        </div>
      </div>
    </AutoplaySlider>
  );
};

export default Slider;



// WEBPACK FOOTER //
// ./src/subcomponents/Slider.js